import React, { useState } from "react";

// (Data)
import CoinInformation from "../coindata";

// (Components)
import Spacer from "../components/Spacer";
import ConnectionModal from "../components/ConnectionModalNew";
import Navbar from "../components/Navbar";

const WalletPage = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [clickedInfo, setClickedInfo] = useState({});

  const enableModalHandler = (id) => {
    setIsOpenModal(true);

    CoinInformation.filter((item) => {
      if (item.id === id) {
        return setClickedInfo(item);
      }
      return null;
    });

    return;
  };

  return (
    <>
      {/* // CONNECT WALLET MODAL */}
      {isOpenModal && (
        <ConnectionModal
          setIsOpenModal={setIsOpenModal}
          clickedInfo={clickedInfo}
        />
      )}

      <Navbar />

      <main className="home-page w-ful flex flex-col gap-y-10">
        <section className="w-full min-w-full max-w-full pb-6">
          <Spacer>
            <div className="w-full py-10">
              <div>
                <div className="text-white flex flex-col justify-center items-center">
                  <h2 className="fancy font-black md:text-5xl text-3xl capitalize mb-10">
                    Explorer
                  </h2>
                </div>

                <div className="w-full max-w-4xl mx-auto grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 md:gap-10 gap-y-10 gap-x-4 mt-6 md:mt-10">
                  {CoinInformation.map((coin) => {
                    return (
                      <div
                        className="w-full relative cursor-pointer"
                        key={coin.id}
                        onClick={() => enableModalHandler(coin.id)}
                      >
                        <div className="relative w-full min-h-[200px] py-2 px-4 overflow-hidden bg-[#1b203d1c] backdrop-blur-xl border border-[#eeeeee]/10 shadow rounded-[30px] flex flex-col items-start gap-x-3 gap-y-4 cursor-pointer">
                          <img
                            src={coin.image}
                            alt={coin.name}
                            className="w-[80%] h-[80%] rounded absolute top-[10%] left-[10%] right-[10%] -z-20 blur-3xl"
                            draggable={false}
                          />
                        </div>

                        <div className="w-full h-full absolute top-0 left-0 right-0">
                          <div className="w-[120px] h-[120px] min-w-[120px] max-w-[120px] bg-white rounded-full relative -top-5 left-5 cursor-pointer">
                            <img
                              src={coin.image}
                              alt={coin.name}
                              className="w-full h-full rounded-full"
                              draggable={false}
                            />
                          </div>

                          <div className="w-full text-white px-6 py-2">
                            <p className="font-light">WALLET</p>
                            <h3 className="font-semibold text-md opacity-95">
                              {coin.name}{" "}
                            </h3>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </Spacer>
        </section>
      </main>
    </>
  );
};

export default WalletPage;
